import { createAsyncLocalStorage } from './async-local-storage';
export const workUnitAsyncStorage = createAsyncLocalStorage();

//# sourceMappingURL=work-unit-async-storage-instance.js.map